/*=============================================== InputCounterPage ===============================================*/

import { useState } from "react"
import { InputCounter } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import {
    commonProps,
    inputLabel,
    inputBackgroundColor,
    iconBoxicon,
} from "data"

const InputCounterPage = () => {
    const [counter, setCounter] = useState<number>(1)

    const items: ItemType[] = [
        {
            content: (
                <InputCounter
                    id="counter"
                    value={counter}
                    setValue={setCounter}
                    min={1}
                    max={30}
                    label="Counter"
                />
            ),
            code: 'const [counter, setCounter] = useState(1)\n\n<InputCounter id="counter" value={counter} setValue={setCounter} min={1} max={30} label="Counter" />',
            codeTs: 'const [counter, setCounter] = useState<number>(1)\n\n<InputCounter id="counter" value={counter} setValue={setCounter} min={1} max={30} label="Counter" />',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "value",
            type: "number",
            required: true,
        },
        {
            subtitle: "setValue",
            type: "function",
            required: true,
        },
        {
            subtitle: "isInputEditable",
            intro: (
                <>
                    Show or hide the <code>input</code> between both buttons.
                </>
            ),
            type: "boolean",
            default: "true",
        },
        {
            subtitle: "showButtonsLabels",
            type: "boolean",
        },
        inputBackgroundColor("backgroundColorInput"),
        "separator",
        {
            subtitle: "icons",
            type: "object",
        },
        {
            title: (
                <>
                    <code>icons</code> object
                </>
            ),
            subtitle: "minus",
            intro: commonProps.addIconCapital,
            type: "string",
            default: iconBoxicon("minus"),
        },
        {
            subtitle: "plus",
            type: "string",
            default: iconBoxicon("plus"),
        },
        "separator",
        {
            subtitle: "labelButtons",
            type: "object",
        },
        {
            title: (
                <>
                    <code>labelButtons</code> object
                </>
            ),
            subtitle: "minus",
            type: "string",
            default: "Minus",
        },
        {
            subtitle: "plus",
            type: "string",
            default: "Plus",
        },
        ...inputLabel(),
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default InputCounterPage
